export default __webpack_public_path__ + "static/media/agency-bookkeeping.08909690.png";